import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { format } from 'date-fns';

import { formatMoney } from '../../../../../utils/helpers';
import { PayoffTooltipIcon } from '../PayoffTooltipCopy';
import { PayoffDisplay, payoffLabel } from '../hooks/usePayoffDisplay';
import { calmPulseAnimation } from './animations';

type PayoffStatSlotProps = {
  display: PayoffDisplay;
  align?: 'left' | 'right';
};

const PayoffStatSlot = ({ display, align = 'right' }: PayoffStatSlotProps) => {
  if (display.mode === 'none') return null;

  const textAlign = align === 'right' ? 'right' : 'left';
  const justify = align === 'right' ? 'flex-end' : 'flex-start';
  const isNumberMode = display.mode === 'number' || display.mode === 'updating';

  const label = (
    <HStack spacing={1.5} justify={justify}>
      <Text
        fontSize="11px"
        fontWeight="700"
        letterSpacing="0.08em"
        textTransform="uppercase"
        color="whiteAlpha.700"
        lineHeight="1"
      >
        {payoffLabel(display.showsTrustedNumber)}
      </Text>
      <PayoffTooltipIcon color="whiteAlpha.700" boxSize="12px" />
    </HStack>
  );

  if (!isNumberMode) {
    return (
      <Box textAlign={textAlign} maxW={{ base: 'none', md: '300px' }}>
        {label}
        <Text fontSize="13px" fontWeight="600" color="white" mt="6px" lineHeight="1.45">
          {display.sentence}
        </Text>
      </Box>
    );
  }

  return (
    <Box textAlign={textAlign}>
      {label}
      <HStack spacing={1.5} justify={justify} mt="4px">
        {display.showsTrustedNumber && <Icon as={FaCheck} color="leaseEndGreen" boxSize="14px" />}
        <Text fontSize="24px" fontWeight="700" color="white" lineHeight="1.1">
          {formatMoney(display.amount, { noCents: true })}
        </Text>
      </HStack>
      {display.mode === 'updating' ? (
        <HStack spacing={1.5} justify={justify} mt="3px">
          <Box
            w="6px"
            h="6px"
            borderRadius="full"
            bg="leaseEndYellow"
            animation={calmPulseAnimation}
          />
          <Text
            fontSize="12px"
            fontWeight="600"
            color="leaseEndYellow"
            animation={calmPulseAnimation}
          >
            Updating your payoff
          </Text>
        </HStack>
      ) : (
        display.goodThroughDate != null && (
          <Text fontSize="12px" color="whiteAlpha.700" mt="3px">
            Good through {format(display.goodThroughDate, 'M/d')}
          </Text>
        )
      )}
    </Box>
  );
};

export default PayoffStatSlot;
